import React from 'react'
import Navbar from './../components/Navbar';
import Footer from "../components/Footer";
import HeroImage2 from './../components/HeroImage2';
import Form from '../components/FormContact';


const Contact = () => {
  return (
    <div>
      <Navbar />
      <HeroImage2  heading="CONTACT" text="Please fill the following form"/>
      <Form />
      <Footer />
      
    </div>
  )
}

export default Contact
